import styled from 'styled-components'
import bg from '../../assets/myevent-accessory-bg.png'
import avatarBg from '../../assets/myevent-avatar-bg.png'

export const AvatarContainer = styled.div`
  background: url(${avatarBg});
  width: 188px;
  height: 188px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 130px 0 30px;
  position: relative;
`

export const Accessory = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
`

export const Relative = styled.div`
  position: relative;
`

export const Bg = styled.div`
  background-image: url(${bg});
  background-size: cover;
  background-position: center bottom;
  background-repeat: no-repeat;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: 290px;
  z-index: -1;
`

export const Title = styled.span`
  font-family: Helvetica Neue;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: center;
  margin: 5px 0;
`

export const Text = styled.span`
  font-family: Helvetica Neue;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: center;
  max-width: 250px;
  margin: 20px 0 50px;
`

export const StepsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Step = styled.div`
  position: relative;
  width: 33px;
  height: 33px;
  border: 1px solid ${({ isActive }) => (isActive ? '#FF5E6D' : '#d8d8d8')};
  background-color: ${({ isActive }) => (isActive ? '#FF5E6D' : 'transparent')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#d8d8d8')};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: Helvetica Neue;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: center;
  margin-right: 14px;

  :not(:nth-last-child(2)):before {
    content: '';
    display: block;
    height: 1px;
    width: 14px;
    background-color: ${({ isActive }) => (isActive ? '#FF5E6D' : '#FFE5E7DD')};
    position: absolute;
    left: calc(100% + 1px);
    top: ;
  }
`
